import Cookies from 'js-cookie';

export const setGUIDHash = (hash: string) => {
  if (hash) {
    Cookies.set('guidH', hash, {
      expires: 365,
    });
  }
  return hash;
};

export const getGUIDHash = () => Cookies.get('guidH');
